import React, {createContext, useCallback, useContext, useState} from 'react';
import {useStickyState} from "@lb/mlib-components";

const LocationsContext = createContext({
    locations: '',
    loadingLocations: false,
    updateLocations: () => {
    },
    setLocationsLoading: () => {
    },

});

export const useLocations = () => {
    return useContext(LocationsContext);
};

export const LocationsProvider = ({children}) => {
        const [locations, setLocations] = useStickyState([], 'locations');
        const [loadingLocations, setLocationsLoading] = useState(false);

        const updateLocations = useCallback(locations => {
            setLocations(locations);
        }, [setLocations])

        const contextValue = {
            locations: locations,
            loadingLocations: loadingLocations,
            updateLocations: updateLocations,
            setLocationsLoading: setLocationsLoading
        };

        return (
            <LocationsContext.Provider value={contextValue}>
                {children}
            </LocationsContext.Provider>
        );
    }
;

export default LocationsContext